import Navigation from "../navigaton/Navigation";
const Header = () => {
  return (
    <div>
      <Navigation />
    </div>
  );
};

export default Header;
